module.exports = __webpack_public_path__ + "static/media/rided0.5e2d1e4b.wav";